//== Components
import '~/js/modules/stickyNav';
import RoomsSuites from '~/js/views/resorts/components/RoomsSuites';

//== Modules
import '~/js/modules/countdown';

// FreeMarker Variables
const internals = {
    resortCode: window.sandals_app.page.resortCode,
    uris: window.sandals_app.page.uris,
    resortName: window.sandals_app.page.resortName,
    filters: {
        roomType: window.sandals_app.page.queryParams.category
    },
};


const reactRoomsAndSuites = query('.rct-rooms-suites');

const validRoomType = (roomTypeParam) => {

    const roomTypeRegEx = /(LUXURY)|(CLUB)|(BUTLER)|(LOVENEST)/gi;

    if (roomTypeRegEx.test(roomTypeParam)) {

        return roomTypeParam.toUpperCase();

    }

    return 'ALL';
};

internals.filters.roomType = validRoomType(internals.filters.roomType);

ReactDOM.render(
	<RoomsSuites
		resortCode={internals.resortCode}
		uris={ internals.uris }
		resortName={ internals.resortName }
		filters={internals.filters}
	/>,
	reactRoomsAndSuites
);
